<main-header></main-header>

<div class="settings-container content-container">
  <div class="settings-header">
    <button class="back-btn" (click)="goBack()">
      <span class="back-arrow">←</span>
      Back
    </button>
    <h1>Settings</h1>
  </div>

  <div class="settings-section --compact">
    <h2>
      <img src="/assets/images/settings.svg" alt="Sound" />
      Sound preferences
    </h2>
    <p class="section-description">
      Choose when this device plays queue sounds <br />
      (Does not affect printer and monitors)
    </p>

    <div class="sound-group">
      <div class="sound-group-header">
        <div class="sound-info">
          <span class="sound-title">New ticket sounds</span>
          <span class="sound-subtitle">Play sound when customers get a new ticket in queue</span>
        </div>
        <button class="toggle-btn" [class.--enabled]="soundSettings.playNewTokenSound" (click)="toggleSoundEnabled()">
          <span class="toggle-track">
            <span class="toggle-thumb"></span>
          </span>
        </button>
      </div>

      <div class="sound-row --nested">
        <div class="sound-info">
          <span class="sound-title">Sound trigger</span>
          <span class="sound-subtitle">Choose when sound is triggered</span>
        </div>
        <select
          class="sound-select"
          [(ngModel)]="soundSettings.behaviour"
          (change)="setSoundBehaviour(soundSettings.behaviour)"
          [disabled]="!soundSettings.playNewTokenSound"
        >
          <option value="people_in_queue_from_0_to_1">From 0 to 1</option>
          <option value="all_new_tokens">Every new ticket</option>
        </select>
      </div>
    </div>

    <div class="sound-row">
      <div class="sound-info">
        <span class="sound-title">Serving call sounds</span>
        <span class="sound-subtitle">Play a sound when a customer is called to the counter.</span>
      </div>
      <button class="toggle-btn" [class.--enabled]="soundSettings.playServingSound" (click)="toggleServingSoundEnabled()">
        <span class="toggle-track">
          <span class="toggle-thumb"></span>
        </span>
      </button>
    </div>
  </div>

  <div class="settings-section" *ngIf="isBranchQueueControlEnabled">
    <h2>
      <img src="/assets/images/queue.svg" alt="Queues" />
      Queues
    </h2>
    <p class="section-description">Enable or disable branch queues. Disabled queues will not be visible to customers.</p>

    <div class="loading-state" *ngIf="isLoading">
      <div class="spinner"></div>
      <span>Loading queues...</span>
    </div>

    <div class="error-state" *ngIf="error">
      <span>{{ error }}</span>
      <button (click)="loadBranchQueues()">Retry</button>
    </div>

    <div class="queue-list" *ngIf="!isLoading && !error">
      <div class="queue-item" *ngFor="let queue of branchQueues">
        <div class="queue-info">
          <span class="queue-name">{{ queue.name }}</span>
          <span class="queue-status" [class.--disabled]="queue.forcedDisabled">
            {{ queue.forcedDisabled ? 'Disabled' : 'Enabled' }}
          </span>
        </div>
        <button
          class="toggle-btn"
          [class.--enabled]="!queue.forcedDisabled"
          [class.--loading]="queue.loading"
          [disabled]="queue.loading"
          (click)="toggleQueue(queue)"
        >
          <span class="toggle-track">
            <span class="toggle-thumb"></span>
          </span>
        </button>
      </div>

      <div class="empty-state" *ngIf="branchQueues.length === 0">No branch queues found.</div>
    </div>
  </div>
</div>
